import { render, staticRenderFns } from "./businessAccountBanner.vue?vue&type=template&id=2bea573c"
import script from "./businessAccountBanner.vue?vue&type=script&lang=js"
export * from "./businessAccountBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports